var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358.43 283.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    d: "M347.14,8.55h-68.07c-3.77,0-7.03,2.63-7.82,6.32l-6.48,30.07-2.03,9.43H10.75c-4.42,0-8,3.58-8,8,0,.63,.07,1.26,.22,1.87l28.96,120.7c.86,3.6,4.08,6.14,7.78,6.13H233.3l-1.74,8.07-4.43,20.58H72.57c-3.53,0-6.65,2.32-7.66,5.7l-2.57,8.56c-1.27,4.23,1.13,8.69,5.36,9.96,4.23,1.27,8.69-1.13,9.96-5.36l.86-2.86H233.6c3.77,0,7.03-2.63,7.82-6.32l6.51-30.26,33.2-154.2,4.39-20.39h61.61c4.42,0,8-3.58,8-8s-3.58-8-8-8",
    fill: "#d0d0cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    d: "M70,247.03c-5.93,0-10.74-4.81-10.74-10.75,0-1.04,.15-2.08,.45-3.08l2.57-8.56c1.34-4.56,5.54-7.68,10.29-7.66H224.92l4.99-23.16H39.7c-4.97,.01-9.3-3.4-10.45-8.24L.3,64.88c-1.38-5.77,2.17-11.57,7.94-12.95,.82-.2,1.66-.3,2.51-.3h249.78l8.04-37.34c1.08-4.94,5.45-8.46,10.5-8.48h68.07c5.93,0,10.74,4.81,10.74,10.75,0,5.93-4.81,10.74-10.74,10.74h-59.39l-43.64,202.69c-1.08,4.94-5.45,8.46-10.5,8.48H80.56l-.27,.9c-1.38,4.53-5.55,7.64-10.29,7.66m2.57-24.57c-2.33-.01-4.38,1.52-5.04,3.75l-2.57,8.56c-.83,2.79,.75,5.72,3.54,6.55,.49,.15,.99,.22,1.5,.22,2.32-.01,4.36-1.53,5.03-3.75l1.44-4.81H233.6c2.47-.01,4.61-1.74,5.14-4.15L283.31,21.81h63.82c2.9-.04,5.23-2.43,5.18-5.33-.04-2.85-2.34-5.15-5.18-5.18h-68.07c-2.47,.01-4.61,1.74-5.14,4.15l-8.97,41.67H10.75c-2.9,0-5.26,2.35-5.26,5.26,0,.41,.05,.83,.15,1.23l28.95,120.7c.56,2.37,2.68,4.04,5.11,4.03H236.7l-7.35,34.14H72.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    x: 65.12,
    y: 144.99,
    width: 29.92,
    height: 28.93,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    x: 65.12,
    y: 69.22,
    width: 29.92,
    height: 26.64,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    x: 65.12,
    y: 106.84,
    width: 29.92,
    height: 27.18,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    x: 106.01,
    y: 144.99,
    width: 29.92,
    height: 28.93,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1467",
    x: 106.01,
    y: 106.84,
    width: 29.92,
    height: 27.18,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    d: "M27.4,95.87h26.75v-26.64H21.01l6.39,26.64Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1468",
    x: 106.01,
    y: 69.22,
    width: 29.92,
    height: 26.64,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    d: "M36.56,134.02h17.59v-27.18H30.04l6.52,27.18Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    d: "M46.13,173.92h8.02v-28.93h-14.96l6.94,28.93Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    d: "M228.69,173.92h8.18l6.23-28.93h-14.41v28.93Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    d: "M228.69,134.02h16.77l5.85-27.18h-22.62v27.18Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1469",
    x: 187.8,
    y: 69.22,
    width: 29.92,
    height: 26.64,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    x: 146.9,
    y: 144.99,
    width: 29.92,
    height: 28.93,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    x: 187.8,
    y: 144.99,
    width: 29.92,
    height: 28.93,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    d: "M228.69,95.87h24.99l5.74-26.64h-30.72v26.64Z",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    x: 187.8,
    y: 106.84,
    width: 29.92,
    height: 27.18,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    x: 146.9,
    y: 106.84,
    width: 29.92,
    height: 27.18,
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    x: 146.9,
    y: 69.22,
    width: 29.92,
    height: 26.64,
    fill: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    d: "M342.27,29.33h-35.51c-7.34-.06-13.24-6.07-13.18-13.41,.06-7.25,5.93-13.11,13.18-13.18h35.51c7.34,.06,13.24,6.07,13.18,13.41-.06,7.25-5.93,13.11-13.18,13.18",
    fill: "#f05d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    d: "M342.27,32.07h-35.51c-8.86-.07-15.98-7.31-15.91-16.16,.07-8.76,7.15-15.84,15.91-15.91h35.51c8.86-.07,16.09,7.05,16.16,15.91,.07,8.86-7.05,16.09-15.91,16.16-.08,0-.17,0-.25,0m-35.51-26.58c-5.83,0-10.55,4.72-10.55,10.55s4.72,10.55,10.55,10.55h35.51c5.83,0,10.55-4.72,10.55-10.55s-4.72-10.55-10.55-10.55h-35.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    d: "M62.54,280.93c-13.49,0-24.43-10.94-24.43-24.43,0-13.49,10.94-24.43,24.43-24.43s24.43,10.94,24.43,24.43c-.01,13.48-10.94,24.41-24.43,24.43m0-35.6c-6.17,0-11.17,5-11.17,11.17,0,6.17,5,11.17,11.17,11.17,6.17,0,11.17-5,11.17-11.17,0-6.17-5-11.16-11.17-11.17",
    fill: "#666766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    d: "M62.54,283.67c-15.01,0-27.17-12.16-27.17-27.17,0-15.01,12.16-27.17,27.17-27.17s27.17,12.16,27.17,27.17h0c-.02,15-12.17,27.15-27.17,27.17m0-48.85c-11.98,0-21.68,9.71-21.68,21.68s9.71,21.68,21.68,21.68,21.68-9.71,21.68-21.68c-.01-11.97-9.71-21.67-21.68-21.68m0,35.6c-7.68,0-13.91-6.23-13.91-13.91,0-7.68,6.23-13.91,13.91-13.91,7.68,0,13.91,6.23,13.91,13.91,0,7.68-6.23,13.9-13.91,13.91m0-22.34c-4.65,0-8.42,3.77-8.42,8.42s3.77,8.42,8.43,8.42,8.42-3.77,8.42-8.42h0c0-4.65-3.77-8.42-8.43-8.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    d: "M229.76,280.93c-13.49,0-24.43-10.94-24.43-24.43s10.94-24.43,24.43-24.43,24.43,10.94,24.43,24.43c-.01,13.48-10.94,24.41-24.43,24.43m0-35.6c-6.17,0-11.17,5-11.17,11.17s5,11.17,11.17,11.17,11.17-5,11.17-11.17c0-6.17-5-11.16-11.17-11.17",
    fill: "#666766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    d: "M229.76,283.67c-15.01,0-27.17-12.16-27.17-27.17s12.16-27.17,27.17-27.17,27.17,12.16,27.17,27.17h0c-.02,15-12.17,27.15-27.17,27.17m0-48.85c-11.98,0-21.68,9.71-21.68,21.68,0,11.98,9.71,21.68,21.68,21.68s21.68-9.71,21.68-21.68h0c-.01-11.97-9.71-21.67-21.68-21.68m0,35.6c-7.68,0-13.91-6.23-13.91-13.91,0-7.68,6.23-13.91,13.91-13.91,7.68,0,13.91,6.22,13.91,13.9,0,7.68-6.23,13.9-13.91,13.91m0-22.34c-4.65,0-8.43,3.77-8.43,8.42s3.77,8.42,8.42,8.42c4.65,0,8.43-3.77,8.43-8.42h0c0-4.65-3.77-8.42-8.42-8.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    d: "M129.76,116.87c0,8.08-6.55,14.63-14.63,14.63-8.08,0-14.63-6.55-14.63-14.63,0-8.08,6.55-14.63,14.63-14.63s14.63,6.55,14.63,14.63h0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    d: "M182.12,116.87c0,8.08-6.55,14.63-14.63,14.63-8.08,0-14.63-6.55-14.63-14.63s6.55-14.63,14.63-14.63,14.63,6.55,14.63,14.63h0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    d: "M129.2,152.79c.81-.45,1.33-1.28,1.39-2.21,.15-2.5,1.34-4.82,3.28-6.4,1.23-.97,2.71-1.59,4.26-1.79,2.13-.39,4.32-.22,6.37,.5,2.82,1.02,4.85,3.53,5.26,6.5,.06,.32,.1,.64,.13,.97-.04,1.36,.92,2.55,2.25,2.79l.95,.02c1.51-.34,2.47-1.84,2.13-3.35,0,0,0,0,0-.01-.18-1.63-.6-3.22-1.24-4.72-1.27-3.16-3.74-5.69-6.88-7.01-2.11-.86-4.38-1.28-6.66-1.24-2.68-.08-5.35,.5-7.76,1.68-3.16,1.67-5.54,4.52-6.61,7.94-.41,1.15-.68,2.35-.82,3.56-.23,1.41,.68,2.75,2.07,3.05,.04,.01,.1,0,.11,.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    d: "M187.06,97.49c-.08,.33-.19,.64-.33,.95-.46,.9-1.39,1.46-2.4,1.43-2.2-.03-4.4-.22-6.57-.57-4.49-.64-8.88-1.89-13.04-3.7-2.47-1.08-4.81-2.44-6.98-4.05-1.01-.73-1.43-2.03-1.03-3.21,.54-1.39,2.1-2.08,3.49-1.55,.27,.1,.51,.25,.74,.43,2.18,1.63,4.57,2.96,7.11,3.95,5.19,2.05,10.7,3.18,16.29,3.34,1.28,0,2.39,.9,2.64,2.16,.02,.08,.05,.16,.07,.24v.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    d: "M92.81,97.28c.05-1.35,1.16-2.42,2.51-2.41,5.41-.16,10.76-1.22,15.82-3.14,2.73-1.03,5.31-2.43,7.65-4.16,1.14-.94,2.82-.78,3.76,.35,.28,.34,.48,.75,.56,1.18,.25,1.07-.21,2.19-1.13,2.79-1.98,1.47-4.11,2.73-6.35,3.77-4.2,1.91-8.64,3.23-13.2,3.92-1.79,.29-3.59,.49-5.41,.59-.19,.01-1.45,.06-1.62,.06-1.44,.02-2.61-1.13-2.63-2.57,0-.13,0-.26,.02-.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    d: "M183.33,120.77c-1.53,7.74-8.43,13.24-16.32,13.01-8.91-.26-15.92-7.7-15.66-16.61,.26-8.91,7.7-15.92,16.61-15.66,7.99,.24,14.6,6.28,15.55,14.21,.11,.9,.15,1.81,.1,2.72-.01,.17-.25,2.18-.28,2.34m-13.71-11.21c0-.11-.08,.14-.03,.06-.11,.28-.21,.57-.29,.87-.05,.59-.04,1.18,.04,1.76,.4,2.75,2.95,4.65,5.69,4.25s4.65-2.95,4.25-5.69c-.32-2.21-2.06-3.94-4.27-4.26-2.26-.29-4.44,.93-5.39,3m-11.86,14c1.66,0,3.01-1.34,3.02-3s-1.34-3.01-3-3.02c-1.66,0-3.01,1.33-3.02,2.99-.01,1.66,1.32,3.01,2.97,3.03,0,0,.02,0,.03,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    d: "M129.59,110.53c3.91,8.03,.57,17.71-7.45,21.62-8.03,3.91-17.71,.57-21.62-7.45-.52-1.07-.92-2.19-1.19-3.34-2.06-8.64,3.27-17.32,11.91-19.38,.45-.11,.9-.2,1.36-.26,6.78-.94,12.13,1.59,16.03,7.2,.36,.52,.68,1.06,.96,1.62m-2.71,1.01c0-2.77-2.26-5.02-5.03-5.02s-5.02,2.26-5.02,5.03c0,2.77,2.25,5.01,5.02,5.02,2.78,0,5.03-2.25,5.03-5.03m-21.6,12.02c1.66,.02,3.02-1.31,3.04-2.98,.02-1.66-1.31-3.02-2.98-3.04h0c-1.66-.02-3.02,1.31-3.04,2.98-.02,1.66,1.31,3.02,2.98,3.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    d: "M97.78,152.62c-9.21,0-16.67-3.53-16.67-7.89s7.47-7.9,16.67-7.9,16.67,3.53,16.67,7.89-7.46,7.89-16.67,7.89",
    fill: "#f05d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    d: "M182.54,152.62c-9.21,0-16.67-3.53-16.67-7.89s7.46-7.89,16.67-7.89,16.67,3.53,16.67,7.89-7.46,7.89-16.67,7.89",
    fill: "#f05d7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.0aba02e26155deb6d2ac13310564f110.svg";
export { ForwardRef as ReactComponent };